<div class="relative">
    <input
        id="{{ id }}"
        type="file"
        class="peer sr-only"
        accept="{{ acceptedMimes }}"
        (change)="loadFile($event)"
    />
    <label
        class="flex w-full cursor-pointer items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm transition-colors hover:bg-slate-50 peer-focus:border-primary-500 peer-focus:ring-4 peer-focus:ring-primary-100"
        for="{{ id }}"
    >
        <span
            [ngClass]="{
                'text-slate-800': value,
                'text-slate-400': !value,
            }"
        >
            @if (isObject) {
                {{
                    value
                        ? $any(value).name
                        : ('translate_select_file' | translate)
                }}
            } @else {
                {{
                    (value
                        ? 'translate_file_has_been_selected'
                        : 'translate_select_file'
                    ) | translate
                }}
            }
        </span>
        <i class="fa-light fa-upload text-slate-400"></i>
    </label>
</div>
